<template>
  <v-content class="content-holder d-flex align-items-center p-0">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md4>
          <v-card class="elevation-12">
            <v-toolbar>
              <v-toolbar-title>{{ $t('login.authorization') }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <form action="#">
                <div
                  class="input-holder barcode-input"
                  ref="barcode"
                  id="barcodeInput"
                >
                  <input-with-vk
                    :inputVal="badgeBarcode"
                    :label="loginTexts.barcodeLabel"
                    @input="barcodeInput"
                    @change="barcodeChange"
                    :numeric="true"
                    :autofocus="true"
                  ></input-with-vk>
                </div>
                <div class="input-holder" ref="pin" id="pinInput">
                  <input-with-vk
                    ref="badgePin"
                    :inputVal="badgePin"
                    :label="loginTexts.pinLabel"
                    :type="'password'"
                    @input="pinInput"
                    @change="pinChange"
                    :numeric="true"
                  ></input-with-vk>
                </div>
              </form>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="tryLoginToBackend" :disabled="entering">
                <span v-if="!entering">{{ $t('global.logIn') }}</span>
                <spinner v-else :size="30" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from '@/services/axios'
import store from '@/services/store'
import i18n from '@/plugins/i18n'

export default {
  name: 'GroupLogin',
  data: () => ({
    valid: false,
    badgeBarcode: '',
    badgePin: '',
    barcodeRules: [
      v => !!v || this.loginTexts.barcodeRulesEmpty,
      v => v.length === 13 || this.loginTexts.barcodeRulesError,
    ],
    pinRules: [
      v => !!v || this.loginTexts.pinRulesEmpty,
      v => v.length === 4 || this.loginTexts.pinRulesError,
    ],
    entering: false,
  }),
  components: {
    spinner: async () => await import('../components/Spinner.vue'),
    'virtual-keyboard': async () =>
      await import('../components/VirtualKeyboard.vue'),
    'input-with-vk': async () =>
      await import('../components/InputWithVKeyboard.vue'),
  },
  computed: {
    loginTexts: function() {
      return i18n.messages[i18n.locale].login
    },
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
    testMode: function() {
      return store.state.testMode
    },
    serverEndpoint: function() {
      return this.$store.getters.serverEndpoint
    },
    languages: function() {
      return store.state.languages
    },
    currentLang: function() {
      return store.state.lang
    },
  },
  methods: {
    barcodeFocus() {
      const inputHolder = this.$refs.barcode
      if (inputHolder) {
        const input = inputHolder.querySelector('input')
        if (input) {
          this.$nextTick(() => input.focus())
        }
      }
    },
    pinFocus() {
      const inputHolder = this.$refs.pin
      if (inputHolder) {
        const input = inputHolder.querySelector('input')
        if (input) {
          this.$nextTick(() => input.focus())
        }
      }
    },
    getEanHashSymbol(bc, bcType) {
      var evenVal = 0
      var oddVal = 0
      var stepCount = bcType === 13 ? 6 : 4
      var i = 0
      for (i = 0; i < stepCount; i++) {
        if (!(bcType === 8 && i === stepCount - 1)) {
          evenVal = evenVal + Number(bc.charAt(2 * i + 1))
        }
        oddVal = oddVal + Number(bc.charAt(2 * i))
      }
      if (bcType === 13) {
        evenVal = evenVal * 3
      } else {
        oddVal = oddVal * 3
      }
      var hashSymbol = 10 - ((evenVal + oddVal) % 10)
      return hashSymbol === 10 ? '0' : String(hashSymbol)
    },
    tryLoginToBackend() {
      this.entering = true
      let serverEndpoint = this.$store.getters.serverEndpoint
      if (this.badgeBarcode.length > 0 && this.badgeBarcode.length < 13) {
        this.badgeBarcode =
          '2' + ('00000000000000' + this.badgeBarcode).slice(-11)
        var hashSymbol = this.getEanHashSymbol(this.badgeBarcode, 13)
        this.badgeBarcode = this.badgeBarcode + hashSymbol
      }
      if (this.badgeBarcode === '2000123456782' && !this.badgePin) {
        localStorage.demoMode = true
        store.commit('updateServerAddress')
        serverEndpoint = this.$store.getters.serverEndpoint
        this.badgeBarcode = '2000000000015'
        this.badgePin = '1234'
      } else {
        localStorage.demoMode = false
      }
      console.log('Пытаемся залогиниться по адресу ' + serverEndpoint)
      axios
        .get('/UserInfo', {
          params: {
            barcode: this.badgeBarcode,
            pin: this.badgePin,
          },
        })
        .then(resp => {
          if (resp && resp.data) {
            if (resp.data.status !== '0') {
              this.$emit('showSnack', {
                color: 'error',
                multiLine: true,
                text: `${resp.data.statusDescription}`,
              })
              return
            }

            this.$store.dispatch(
              'updateUserData',
              Object.assign(this.$store.state.userData, {
                token: resp.data.token,
                userId: resp.data.userId,
                userName: resp.data.userName,
              })
            )

            this.$store.dispatch('initApp')
            this.$emit('showSnack', {
              color: 'info',
              multiLine: true,
              text: `${this.loginTexts.logInAs} ${resp.data.userName}. ${this.loginTexts.waitFor}`,
            })
          }
        })
        .catch(e => {
          console.log('get/UserInfo error: ', e)
        })
        .finally(() => (this.entering = false))
    },
    barcodeKeydown(ev) {
      if (ev.keyCode === 13) {
        if (ev.preventDefault) ev.preventDefault()
        this.tryLoginToBackend()
      } else if (ev.keyCode === 8) {
        if (ev.preventDefault) ev.preventDefault()
        this.badgeBarcode = ''
      } else if (ev.keyCode < 48) {
        //do nothing
      } else {
        this.badgeBarcode =
          this.badgeBarcode +
          String.fromCharCode(
            96 <= ev.keyCode && ev.keyCode <= 105 ? ev.keyCode - 48 : ev.keyCode
          )
      }
      this.barcodeFocus()
    },
    barcodeInput(payload) {
      this.badgeBarcode = payload
      this.pinFocus()
    },
    barcodeChange(payload) {
      this.badgeBarcode = payload
    },
    pinInput(payload) {
      this.badgePin = payload
      if (payload) {
        this.tryLoginToBackend()
      }
    },
    pinChange(payload) {
      this.badgePin = payload
    },
  }, //methods
}
</script>

<style scoped lang="scss">
@import '../_scss/breakpoints';
h3 {
  font-size: 18px;
  @include sm {
    font-size: 15px;
  }
}
h4 {
  font-size: 11px;
  @include sm {
    font-size: 8px;
  }
}
.content-holder {
  ::v-deep .v-content__wrap {
    padding: 0;
  }
}
</style>
